import { useState } from "react";
import ModuleHeader from "../../components/ModuleHeader";
import usePermission from "../../hooks/usePermission";
import CompanyExpensesTab from "./CompanyExpensesTab";
import RecurringExpensesTab from "./RecurringExpensesTab";
import CODRepayTab from "./CODRepayTab";
import InvoiceTab from "./InvoiceTab";
import LedgerTab from "./LedgerTab";
import IncentivesTab from "./IncentivesTab";
import EmployeeSalaryTab from "./EmployeeSalaryTab";

const TABS = [
  { key: "company-expenses", label: "Company Expenses" },
  { key: "recurring-expenses", label: "Recurring Expenses" },
  { key: "cod-repay", label: "COD Repay" },
  { key: "invoice", label: "Invoice" },
  { key: "ledger", label: "Ledger" },
  { key: "incentives", label: "Incentives" },
  { key: "employee-salary", label: "Employee Salary" },
];

const TAB_COMPONENTS = {
  "company-expenses": CompanyExpensesTab,
  "recurring-expenses": RecurringExpensesTab,
  "cod-repay": CODRepayTab,
  invoice: InvoiceTab,
  ledger: LedgerTab,
  incentives: IncentivesTab,
  "employee-salary": EmployeeSalaryTab,
};

export default function Accounts() {
  const [activeTab, setActiveTab] = useState("company-expenses");
  const { canView } = usePermission("accounts");

  const ActiveComponent = TAB_COMPONENTS[activeTab];

  return (
    <div>
      <ModuleHeader
        title="Accounts"
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />
      <div style={{ padding: 24 }}>
        {canView ? (
          ActiveComponent && <ActiveComponent />
        ) : (
          <p style={{ textAlign: "center", color: "#94a3b8" }}>
            You do not have permission to view this module.
          </p>
        )}
      </div>
    </div>
  );
}
